module.exports = __webpack_public_path__ + "img/15.469323cd.png";